import * as React from "react"
import type { SVGProps } from "react"
const SvgPlayPause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 16.63v-8.4l6 4.2zm8-.2v-8h2v8zm4 0v-8h2v8z" />
  </svg>
)
export default SvgPlayPause
